import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-emp-salary-allow',
  templateUrl: './emp-salary-allow.component.html',
  styleUrls: ['./emp-salary-allow.component.css']
})
export class EmpSalaryAllowComponent implements OnInit {

  emp_salary_id: string;
  employee_id: string;
  basic_salary: number;

  model = {
    'allow_id': '0','allow_perc': 0, 'is_goci': 0, 'allow_amount': 0, 'basic_salary': 0,
     'type': '', 'allow_name':'', 'index':0
  };

  allowList = [];

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<EmpSalaryAllowComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    this.basic_salary = this.dialog_data['basic_salary'];

    let query = "SELECT * FROM `emp_allowance` WHERE `status` ='1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allowList = data.data['list'];
        
      });

    if (this.dialog_data['type'] == 'edit') {
      this.model = this.dialog_data;
    }
  }

  getAllow() {
    let allow = [];
    let query = "SELECT * FROM `emp_allowance` WHERE `status` ='1' AND `allow_id` = '" + this.model['allow_id'] + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        allow = data.data['list'];
        this.model['allow_perc'] = allow['0']['allow_perc'];
        this.model['is_goci'] = allow['0']['is_goci'];
        this.getAllowAmount();
      });
  }

  getAllowAmount() {
    let allow_amount = 0;
    allow_amount = (this.basic_salary * this.model['allow_perc']) / 100;
    this.model['allow_amount'] = allow_amount;
  }

  add() {
    if (this.model['allow_id'] != '0') {
      this.model['allow_name']= this.allowList['0']['allow_name'];
      this.model['index'] = Number(this.dialog_data['index']);
      if (this.dialog_data['type'] == 'add')
      this.model['index']++;
      this.dialog_data = {
        'allow_detail': this.model,
      };
      this.dialogRef.close(this.dialog_data);

    }
    else if (this.model['allow_id'] == '0') {
      alert("الرجاء اختيار البدل");
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
